import clsx from 'clsx'
import NextLink from 'next/link'

import type { RowProps } from './type'

import { ChevronRightOutlinedIcon } from '@/components/icons/ChevronRightOutlined'

import { Icon } from '../..'

const RowContent = ({ title, value, href, onClick, error }: RowProps) => {
  return (
    <>
      <div
        className={clsx(
          'tw-flex tw-min-h-[44px] tw-items-center tw-justify-between',
          (href !== undefined || onClick !== undefined) &&
            'tw-cursor-pointer tw-transition tw-duration-stateChange hover:tw-opacity-hover'
        )}
        onClick={onClick}
      >
        <p className={clsx('tw-text-sm')}>{title}</p>
        <div className={clsx('tw-flex tw-items-center tw-justify-center')}>
          <span
            className={clsx('tw-text-right tw-text-sm', 'tw-flex tw-flex-col')}
          >
            {value}
          </span>
          {href !== undefined && (
            <Icon
              icon={ChevronRightOutlinedIcon}
              size={'xl'}
              className={clsx('tw--mr-2 tw-text-gray-700')}
            />
          )}
        </div>
      </div>
      {error && (
        <div
          className={clsx('tw-pb-2 tw-text-right tw-text-sm tw-text-alert-500')}
        >
          {error}
        </div>
      )}
    </>
  )
}

export const Row = ({
  title,
  value,
  href,
  external,
  onClick,
  error,
}: RowProps) => {
  if (href !== undefined && external) {
    return (
      <a href={href} target="_blank" rel="noreferrer">
        <RowContent
          title={title}
          value={value}
          href={href}
          error={error}
          onClick={onClick}
        />
      </a>
    )
  }

  return href !== undefined ? (
    <NextLink href={href}>
      <span>
        <RowContent
          title={title}
          value={value}
          href={href}
          error={error}
          onClick={onClick}
        />
      </span>
    </NextLink>
  ) : (
    <RowContent title={title} value={value} onClick={onClick} error={error} />
  )
}
